import type { ReactNode } from 'react'
import { Text } from '@chakra-ui/react'
import { useFormColors } from './FormThemeContext'
import { useResolveText } from '../i18n'

interface FormLabelProps {
  children?: ReactNode
  tid?: string
  values?: Record<string, unknown>
  required?: boolean
  size?: 'sm' | 'xs'
}

export function FormLabel({ children, tid, values, required, size = 'sm' }: FormLabelProps) {
  const c = useFormColors()
  const resolve = useResolveText()
  const content = tid ? resolve(tid, undefined, values) : children
  return (
    <Text fontSize={size} fontWeight="500" color={c.textSecondary} mb={size === 'sm' ? 2 : 1}>
      {content}
      {required && <Text as="span" color={c.error} ml={0.5}>*</Text>}
    </Text>
  )
}
